<template>
    <div class="pe_formmodal">
        <div class="pe_formmodal_close-button"><span @click="$emit('close')">X</span></div>
        <div class="pe_form-container">
            <div v-if="this.gType == 'sudoku'">
                {{ this.gType }}
                <p><strong>Have something to share? Experiencing an issue?</strong></p>
                <p><strong>We value your feedback!</strong></p>
                <p>Complete the contact form below to send us a message.</p>
                <p>Please note, we are unable to answer bug reports individually.</p>
            </div>

            <div v-if="this.gType == 'crossword'">
                {{ this.gType }}
                <p><strong>Have something to share? Experiencing an issue?</strong></p>
                <p><strong>We value your feedback!</strong></p>
                <p>Complete the contact form below to send us a message.</p>
                <p>Please note, we are unable to answer bug reports individually.</p>
            </div>

            <div v-if="this.gType == 'codecracker'">
                {{ this.gType }}
                <p><strong>Have something to share? Experiencing an issue?</strong></p>
                <p><strong>We value your feedback!</strong></p>
                <p>Complete the contact form below to send us a message.</p>
                <p>Please note, we are unable to answer bug reports individually.</p>
            </div>

            <div v-if="this.gType == 'wordsearch'">
                {{ this.gType }}
                <p><strong>Have something to share? Experiencing an issue?</strong></p>
                <p><strong>We value your feedback!</strong></p>
                <p>Complete the contact form below to send us a message.</p>
                <p>Please note, we are unable to answer bug reports individually.</p>
            </div>

            <div v-if="this.gType == 'trivia'">
                {{ this.gType }}
                <p><strong>Have something to share? Experiencing an issue?</strong></p>
                <p><strong>We value your feedback!</strong></p>
                <p>Complete the contact form below to send us a message.</p>
                <p>Please note, we are unable to answer bug reports individually.</p>
            </div>
            
        </div>
    </div>
</template>
  
  <script>
    import { mapState, mapActions } from 'vuex'

  import Spinner from '@puzzleapps/shared/src/components/ui/Spinner'

  export default {
    name: 'support-modal',
    props: ['date'], // date, format YYYY-MM-DD

    components: {
      Spinner,
    },

    data() {
      return {

        }
      },

      mounted() {

    },


    methods: {
        ...mapActions({
            
      }),

    },
    computed: {
      ...mapState({
        game: state => state.game,
        clientAppId: state => state.clientAppId || window.PE_CLIENTAPP_ID,
        stateError: state => state.errors.error,
        gType: state => state.game.type,
      }),
    }
    }

  </script>
  
  <style scoped lang="scss">
  #puzzleapp {
    .pe_formmodal_close-button {
        align-self: flex-end;
        padding: 10px;
        cursor: pointer;
        text-align: right;
        font-size: 1.5em;
      }
    .pe_formmodal {

    position: absolute;
    width: 100%;
    max-width: 100%;
    //top: 1%;
    //left: 1%;
    right: 0;
    top:0;
    height: 100%;
    background: var(--modal-background);
    color: #fff;
    z-index: 30;
     overflow: auto;
    
    }
    .pe_form-container {
        display: flex;
        flex-direction: column;
        gap: 4px;
        max-width: 500px;
        margin: 0 auto;
        padding: 0 8px;
    }
  
    .pe_form-container label {
        //font-weight: bold;
        color:#fff;
        text-align: left;
        padding: 0 5px;
        font-size: 0.8em;
        margin-top: 15px;
    }
  
    .pe_form-container textarea,
    .pe_form-container select {
        border-radius: 4px;
        border: 1px solid #ccc;
        padding: 5px;
        width: 100%;
        
        &.error{
            background: #f38c8c;
            
        }
        option {
            
             
            .error{
                background-color: #f38c8c;
            }
        
        }
    }
    .pe_form-container p{
        color:#fff;
        font-weight: 400;
        font-size: 0.8em;
    }
    .pe_form-container button {
        border-radius: 5px;
        padding: 10px;
        background: var(--crossword-menu-btn-background);
        color: var(--crossword-menu-btn-color);
        cursor: pointer;
        &:hover{
            background: var(--crossword-menu-btn-hover);
            color:#000;
        }
    }


}
  </style>
  